/* eslint-disable */
import React from 'react'
import {Button, Container, Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import {accounting} from 'accounting'
import jMoment from 'moment-jalaali'
import cookie from 'react-cookies'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'

class DeliveryPackPrint extends React.Component {
  constructor(props) {
    super(props)
  }
  componentDidMount() {}

  convertState = (x, y) => {
    if (x == -100) {
      x = 'کنسل'
      // return x;
    } else if (x == -75) {
      x = 'مرجوعی'
      // return x;
    } else if (x == -50) {
      x = 'بازگشتی'
      // return x;
    } else if (x == 100) {
      x = 'تخصیص مجدد'
      // return x;
    } else if (x == -1) {
      x = 'تخصیص داده نشده'
      // return x;
    } else if (x === 1) {
      x = 'فعال'
      // return x;
    } else if (x === 15) {
      x = 'تحویل ناقص'
      // return x;
    } else if (x == 5) {
      x = 'اول فعال'
      // return x;
    } else if (x == 10) {
      x = 'شروع شده'
      // return x;
    } else if (x == 18) {
      x = 'تسویه نشده'
      // return x;
    } else if (x == 20) {
      x = 'تسویه شده'
    }

    if (y) {
      y = 'تخصیص مجدد'
    } else {
      y = ''
    }

    return y == '' ? x : y + ' - ' + x
  }

  render() {
    let reporterName = cookie.load('name')
    let printCol = [
      'ردیف',
      'تاریخ تحویل',
      'بازه تحویل',
      'زمان تحویل',
      'شناسه فاکتور',
      'شماره فاکتور',
      'خریدار',
      'تحویل گیرنده',
      'موبایل',
      'وضعیت',
      'پرداخت در محل',
      'رساننده',
      'اتوموبیل',
      'قابل پرداخت',
      'نقدی',
      'کارتخوان',
      'پرداخت از قبل',
      'حالت',
      'نوع تحویل'
    ]
    let {printInfo, rightSectionPrint, centerSection} = this.props
    return (
      <div className="printSection">
        <table className="printTable printReportTable landscapeTable" ref={(node) => (this.printPart = node)}>
          <HeaderTablePrint
            header={this.props.title ? this.props.title : 'لیست گزارشات پارت تحویل'}
            reporter={reporterName}
            timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
            headerColSpan={19}
            rightColSpan={9}
            centerColSpan={1}
            leftColSpan={9}
            centerSection={centerSection}
            rightSection={rightSectionPrint}
            columns={printCol}
          />

          <tbody>
            {printInfo.map((items, index) => (
              <tr key={'i' + index} style={index % 2 == 0 ? {backgroundColor: '#f1f1f1'} : {backgroundColor: '#fff'}}>
                <td>{index + 1}</td>
                <td>
                  {this.props.title
                    ? jMoment(items.dispatchPlanDate).format('jYYYY/jM/jD')
                    : jMoment(items.planDate).format('jYYYY/jM/jD')}
                </td>
                <td>
                  {this.props.title
                    ? items.dispatchPlanTimeFrom.substr(0, 5) + ' - ' + items.dispatchPlanTimeTo.substr(0, 5)
                    : items.planTimeFrom.substr(0, 5) + ' - ' + items.planTimeTo.substr(0, 5)}
                </td>

                <td>{items.dispatchDate == null ? '-' : jMoment(items.dispatchDate).format('jYYYY/jM/jD HH:mm')}</td>
                <td>{items.invoice.invoiceId}</td>
                <td>{items.invoice.invoiceNum}</td>
                <td>{items.invoice.buyerName}</td>
                <td>{items.invoice.recipientName}</td>
                {/*<td>{items.invoice.address}</td>*/}
                <td className="mobileTD">
                  {items.invoice.mobile == null ? '-' : items.invoice.mobile.replace(/\+98/g, '0')}
                </td>
                <td>{items.invoice.paid ? 'پرداخت شده' : 'پرداخت نشده'}</td>
                <td>{items.invoice.payOnDelivery ? 'بله' : 'خیر'}</td>
                <td>{items.driver == null ? '-' : items.driver.name}</td>
                <td>{items.car == null ? '-' : items.car.code}</td>
                <td className="priceCell">{accounting.formatMoney(items.totalInfo.payableAmount, '', ',')}</td>
                <td className="priceCell">{accounting.formatMoney(items.payment.cash, '', ',')}</td>
                <td className="priceCell">{accounting.formatMoney(items.payment.card, '', ',')}</td>
                <td className="priceCell">{accounting.formatMoney(items.payment.prePaid, '', ',')}</td>
                <td>{this.convertState(items.lastState, items.reAssigned)}</td>
                <td>
                  {items.lastState == '20' && items.hasSign
                    ? ' امضا'
                    : items.lastState == '20' && !items.hasSign
                    ? ' کد'
                    : '-'}
                </td>
              </tr>
            ))}
            {/*<tr>*/}
            {/*    <td colSpan={13}>مجموع</td>*/}
            {/*    <td className='priceCell'>{accounting.formatMoney(aggregation.totalInfo ? aggregation.totalInfo.payableAmount : '','',',')}</td>*/}
            {/*    <td className='priceCell'>{accounting.formatMoney(aggregation.payment? aggregation.payment.cash : '','',',')}</td>*/}
            {/*    <td className='priceCell'>{accounting.formatMoney(aggregation.payment? aggregation.payment.card : '','',',')}</td>*/}
            {/*    <td className='priceCell'>{accounting.formatMoney(aggregation.payment? aggregation.payment.prePaid : '','',',')}</td>*/}
            {/*    <td className='priceCell' colSpan={3}></td>*/}
            {/*</tr>*/}
          </tbody>
        </table>
      </div>
    )
  }
}

export default DeliveryPackPrint
